<script>
	import thumb__HNmVa1XFFE from '$lib/Components/Youtube/images/_HNmVa1XFFE.jpg';

	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import GradeTypes from '$lib/PageSections/GradeTypes/GradeTypes.svelte';
	import WhatDoTheyCost from '$lib/PageSections/WhatDoTheyCost/WhatDoTheyCost.svelte';
	// images
	import image3 from './images/sleep-panel-bottom.png';
	import image1 from './images/sleep-panel-image-001.jpg';
	import image2 from './images/sleep-panel-image-002.jpg';
</script>

<Section backgroundColor="white">
	<h2>Blackout Your Windows for Better Sleep</h2>
	<p>
		Sleep Panels seal out light for total darkness and also block up to 50% of
		noise coming through windows* to create an ideal sleep environment. Unlike
		blackout curtains, shades or blinds, which allow some light around the
		borders, Indow Sleep Panel is edged in silicone <a
			href="/resources/faq/interior-storm-window-inserts-glossary#products"
			>compression tubing</a
		>
		to create true blackout windows.
	</p>
	<Image
		src={image1}
		alt="Indow window sleep panel insert AKA blackout panels."
	/>
	<p>
		This makes it a superior blackout solution for light sleepers or nurses,
		firefighters and others who work night shifts. Research has shown that good
		sleep is vital for your health and that it’s important to create a quiet,
		dark bedroom. For this reason, Indow Sleep Panels have also proven a hit
		with Paleo dieters.
	</p>
	<Bubble title="Sleep Panels:">
		<ul>
			<li>
				<p class="text-left">
					Custom made from medium density fiberboard (MDF) unlike our other
					grades, which are acrylic.
				</p>
			</li>
			<li>
				<p class="text-left">
					A white surface that can be painted or customized in other ways.
				</p>
			</li>
			<li>
				<p class="text-left">
					Installed in minutes. Each window opening is laser measured for a
					precise, snug fit.
				</p>
			</li>
			<li><p class="text-left">Our lowest-priced grade.</p></li>
		</ul>
	</Bubble>
	<p>
		Sometimes people will double up blackout curtains and shades or tack heavy
		blankets over their windows attempting to eliminate light. But it isn’t
		until they press in Indow blackout window inserts that they enjoy total
		darkness. If you’re sensitive to light, suffer migraines or need to sleep
		during the day, the Sleep Panel will create a dark, cool, quiet bedroom.
	</p>
	<Youtube
		posterImageSrc={thumb__HNmVa1XFFE}
		src="https://www.youtube.com/embed/_HNmVa1XFFE"
		title="Blackout Your Windows With Sleep Panels"
	/>
	<Bubble title="How Indow Blackout Solution performs:">
		<ul>
			<li>
				<p class="text-left">
					Provides the same noise reduction and energy efficiency of <a
						href="/custom-storm-windows/standard-grade">Standard Grade</a
					>.
				</p>
			</li>
			<li>
				<p class="text-left">
					50 percent reduction in outside noise when placed over single-pane
					windows.
				</p>
			</li>
			<li>
				<p class="text-left">Up to 20 percent energy savings.</p>
			</li>
			<li>
				<p class="text-left">
					Compression tubing creates a tight fit in the window, completely
					blocking 100% of light unlike blackout shades which often emit
					significant light around the edges.
				</p>
			</li>
		</ul>
	</Bubble>
	<p class="!text-indow-blue text-xl italic">
		<a href="/solutions/block-damaging-uv-light"
			>Explore complete performance data here.</a
		>
	</p>
</Section>

<Section backgroundColor="white">
	<h2>Testimonial on Indow Sleep Panel Ability to Blackout Windows:</h2>
	<p>
		Sleep Panels helped Nicole who is sensitive to light and suffers from
		serious migraines. She had tried using both curtains and shades but it
		wasn’t enough. Indow Sleep Panels blocked all the light.
	</p>
	<p class="!text-indow-blue text-xl italic">
		“If you have light sensitivity or just want an extremely dark room to sleep
		in, I can’t recommend this product enough.”
	</p>
	<Image
		src={image2}
		alt="Indow window sleep panel insert AKA blackout panels."
	/>
	<p class="text-xs italic">
		*We want to ensure our inserts help solve your noise problem. Overall noise
		reduction depends on the amount of noise coming through your walls,
		ceilings, floors, doors, and existing windows. Noise reduction will be less
		when placed over double-pane windows. Read our full <a
			href="/noise-disclaimer">Noise Reduction Sheet</a
		> to learn more.
	</p>
	<p>
		Create a dark bedroom with blackout panels and start sleeping better by
		filling out the form below.
	</p>
</Section>
<WhatDoTheyCost version="2" page="sleep-panel" />
<GetAFreeEstimate />
<GradeTypes backgroundColor="grey" />
<Parallax image={image3} />
<FeaturedArticles />
